import { Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import logo from "../../images/logo.png";

export default function EndExerciseModal({ isEndExercise, handleEndExercise }) {
  return (
    <Modal
      show={isEndExercise}
      onHide={handleEndExercise}
      id=""
      className="modal fade workout-finished-modal custom-fullscreen-modal"
      size="xl"
    >
      <div className="modal-background text-white text-center p-5 position-relative">
        <button
          type="button"
          className="custom-close-btn position-absolute top-0 end-0 m-3"
          onClick={handleEndExercise}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="white"
            viewBox="0 0 16 16"
          >
            <path d="M2.146 2.146a.5.5 0 011 0L8 6.293l4.854-4.854a.5.5 0 11.707.707L8.707 7l4.854 4.854a.5.5 0 01-.707.707L8 7.707l-4.854 4.854a.5.5 0 01-.707-.707L7.293 7 2.146 2.854a.5.5 0 010-.707z" />
          </svg>
        </button>

        <div className="logo mb-4">
          <Link to="/home">
            <img src={logo} alt="logo" className="img-fluid" />
          </Link>
        </div>
        <h2 className="fw-bold mt-5">WORKOUT</h2>
        <h2 className="fw-bold mt-1">FINISHED</h2>
      </div>
    </Modal>
  );
}
